import React, { useState } from 'react';
import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import { Button } from '../../dashboardCommon/components';
import ViewOrder from '../viewOrderVUL';

const View = ({ orderData, onSave, fetchData }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { viewOrder }
  } = localizedStrings;
  const [isViewOrderVisible, setIsViewOrderVisible] = useState(false);

  const showPopUp = () => {
    setIsViewOrderVisible(true);
  };

  const hidePopUp = () => {
    setIsViewOrderVisible(false);
  };

  const onStatusUpdateSuccess = () => {
    window.location.reload();
    hidePopUp();
  };

  return (
    <>
      <Button onClick={() => showPopUp()}>{viewOrder}</Button>
      {isViewOrderVisible && (
        <ViewOrder
          orderData={orderData}
          open={isViewOrderVisible}
          setOpen={setIsViewOrderVisible}
          onStatusUpdateSuccess={onStatusUpdateSuccess}
          onSave={onSave}
          fetchData={fetchData}
        />
      )}
    </>
  );
};

export default View;
